import { TimelineMax, Power0, Power1, Sine } from 'gsap'

export default {
  data () {
    return {
      tlHead: new TimelineMax(),
      tlEyes: new TimelineMax({repeat: -1, repeatDelay: 3.7}),
      eyesDelay: 2,
      headDelay: 0
    }
  },

  mounted () {
    const head = this.$el.querySelector('.head')
    const arm = this.$el.querySelector('.arm')
    const ears = this.$el.querySelectorAll('.ear')
    const eyes = this.$el.querySelectorAll('.eyes')
    const brows = this.$el.querySelectorAll('.brow')
    const mouth = this.$el.querySelector('.spath')
    const headProps = { rotationZ: 5, xPercent: 6, yPercent: -5 }
    const armProps = { rotationZ: -15, xPercent: 6 }
    const earsProps = { rotation: -4 }
    const eyesProps = { scaleY: 0 }

    this.tlHead
      .delay(this.headDelay)
      .from(head, 2, {...headProps, z: 0.01, force3D: true, ease: Power1.easeInOut, repeat: -1, yoyo: true, repeatDelay: 0.7})
      .from(ears, 2, {...earsProps, ease: Power0.easeNone, repeat: -1, yoyo: true}, 0.2)
      .to(arm, 2, {...armProps, transformOrigin: '100% 100%', ease: Power0.easeNone, repeat: -1, yoyo: true}, 0)

    this.tlEyes
      .delay(this.eyesDelay)
      .to(eyes, 0.5, { ...eyesProps, transformOrigin: '50% 50%', ease: Power0.easeNone, yoyo: true, repeat: 1 })
      .fromTo(brows, 0.8, {y: 0}, {y: -2, ease: Sine.easeInOut, yoyo: true, repeat: 1, repeatDelay: 0.2}, 0.2)
      .to(mouth, 1, { scaleX: 1.2, svgOrigin: '173 113', ease: Sine.easeInOut, yoyo: true, repeat: 1, repeatDelay: 0.1 }, 0)
  },

  beforeDestroy () {
    this.tlHead.kill()
    this.tlEyes.kill()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/timelines/bearWpd.js